// https://prototype.sqprod.co/#/docs/squareup.api.items.CalculationPhase
var CalculationPhase = /*#__PURE__*/function (CalculationPhase) {
  CalculationPhase["DiscountPercentagePhase"] = "DISCOUNT_PERCENTAGE_PHASE";
  CalculationPhase["DiscountAmountPhase"] = "DISCOUNT_AMOUNT_PHASE";
  CalculationPhase["FeeSubtotalPhase"] = "FEE_SUBTOTAL_PHASE";
  CalculationPhase["FeeTotalPhase"] = "FEE_TOTAL_PHASE";
  CalculationPhase["TipPhase"] = "TIP_PHASE";
  CalculationPhase["SwedishRoundingPhase"] = "SWEDISH_ROUNDING_PHASE";
  CalculationPhase["SurchargePhase"] = "SURCHARGE_PHASE";
  CalculationPhase["SurchargeTotalPhase"] = "SURCHARGE_TOTAL_PHASE";
  CalculationPhase["ApportionedSurchargePercentagePhase"] = "APPORTIONED_SURCHARGE_PERCENTAGE_PHASE";
  CalculationPhase["ApportionedSurchargeAmountPhase"] = "APPORTIONED_SURCHARGE_AMOUNT_PHASE";
  CalculationPhase["CardSurchargePhase"] = "CARD_SURCHARGE_PHASE";
  return CalculationPhase;
}(CalculationPhase || {});
export default CalculationPhase;